import React from 'react';
import PropTypes from 'prop-types';
import { BrandHeader } from '@fuww/library/src/CompanyProfile';
import Layout from '../Layout';
import HeaderImage from './HeaderImage';
import Image from '../Image';
import throw404 from '../../lib/throw404';

const Company = ({
  data: { profileBySlug },
  children,
  layoutMaxWidth,
  layoutMarginBottom,
  throwOnCompanyNotFound,
}) => {
  if (!profileBySlug) { return throw404(); }

  const {
    type,
    page: {
      title,
      contactDetails,
    },
    company: {
      logoUrls,
    },
  } = profileBySlug;

  if (throwOnCompanyNotFound && type !== 'COMPANY') { return throw404(); }

  return (
    <Layout
      overflow="visible"
      header={(
        <>
          <HeaderImage profile={profileBySlug} />
          {title && (
            <BrandHeader
              logo={logoUrls[0] && (
                <Image
                  src={logoUrls[1]}
                  alt={`Logo ${title}`}
                  width="102px"
                  height="102px"
                  sizes="102px"
                  placeholder={logoUrls[0]}
                  srcSet={`${logoUrls[1]
                  } 102w, ${logoUrls[2]
                  } 204w, ${logoUrls[3]
                  } 306w`}
                  finalFetchpriority="high"
                  placeholderFetchpriority="high"
                  preload
                  disableRoundedCorners
                />
              )}
              brandName={title}
              contactInfo={contactDetails}
            />
          )}
        </>
      )}
      layoutMaxWidth={layoutMaxWidth}
      layoutMarginBottom={layoutMarginBottom}
    >
      {children}
    </Layout>
  );
};

Company.propTypes = {
  data: PropTypes.shape({
    profileBySlug: PropTypes.shape({
      page: PropTypes.shape({
        title: PropTypes.string,
        contactDetails: PropTypes.string,
      }),
      company: PropTypes.shape({
        logoUrls: PropTypes.arrayOf(PropTypes.string),
      }),
      type: PropTypes.string,
    }),
  }).isRequired,
  children: PropTypes.node.isRequired,
  layoutMaxWidth: PropTypes.string.isRequired,
  layoutMarginBottom: PropTypes.string,
  throwOnCompanyNotFound: PropTypes.bool,
};

Company.defaultProps = {
  layoutMarginBottom: null,
  throwOnCompanyNotFound: false,
};

export default Company;
